module.exports = __webpack_public_path__ + "static/hero-1ba75b441df97eb1a6e152590c274860.jpg";